import { Component, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error?: Error };

export class ErrorBoundary extends Component<Props, State> {
  state: State = {};

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    // Log for debugging in production.
    // eslint-disable-next-line no-console
    console.error('[WhyIslam] Uncaught render error', error);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', color: '#0f172a' }}>
          <h1 style={{ margin: '0 0 10px', fontSize: 18 }}>Something went wrong</h1>
          <p style={{ margin: 0, opacity: 0.8 }}>
            The page crashed while rendering. Please reload. If this persists, share this message:
          </p>
          <pre
            style={{
              marginTop: 12,
              padding: 12,
              borderRadius: 12,
              background: 'rgba(15,23,42,0.06)',
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {this.state.error.message}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

